import { WprBaseViewCoreComponent } from './WprBaseViewCoreComponent';
import { IWprRouteViewProps } from '../props/IWprRouteViewProps';

/**
 * ビューコンポーネント基本クラス
 */
export abstract class WprBaseRouteViewComponent extends WprBaseViewCoreComponent<IWprRouteViewProps> {
}
